import React, { useEffect } from 'react';
import './psatencionjuv.css';
import { psatencionjuv } from '../../json/psatencionjuv';

const Psatencionjuv = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa Atención a la Juventud</h3>
          <hr className='hr-gob' />
        </div>
      </div>

      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold' }}>Descripción del Programa</h5>
                <p>
              
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                Que el Programa Atención a la Juventud se enfoca a contribuir a la mejora de la calidad de vida de las y los jóvenes, implementando políticas que alcancen a satisfacer las necesidades más sentidas en temas como educación, desarrollo integral y emprendimiento; buscando que los jóvenes puedan ser partícipes del desarrollo de sus comunidades y del estado. El Programa asume el cambio institucional y de políticas públicas desde la perspectiva de infancia y adolescencia al considerar la observancia de los objetivos nacionales para promover y garantizar los derechos de las Niñas, Niños y Adolescentes, que se corresponden con los Objetivos de Desarrollo Sostenible de la Agenda 2030, a fin de dar cumplimiento a lo que establece la Ley General en la materia, a los tratados internacionales de los que el Estado Mexicano es parte, e impactar positivamente las condiciones y calidad de vida de la Niñas, Niños y Adolescentes, reducir las brechas de desigualdad; prevenir y reducir la violencia; así como combatir el trabajo infantil y la discriminación.
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Objetivo del Programa</h5>
                <p>
                Contribuir al desarrollo integral de la juventud hidalguense, mediante las intervenciones y acciones en materia de salud, empleo y participación juvenil, a fin de mejorar la calidad de vida de las y los jóvenes.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Población Objetivo</h5>
                <p>
                Jóvenes hidalguenses con edad comprendida entre los 12 a 29 años, dando cobertura a los 84 municipios del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Cobertura</h5>
                <p>
                Estatal
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Áreas de atención</h5>
                <p>
                  
                  <ul>
                  <li>Secretaría de Bienestar en Inclusión Social<br />                    
                  </li>
                  <li>Dirección General del <a
                href='https://juventud.hidalgo.gob.mx/'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Instituto Hidalguense de la Juventud</a>
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Personas Responsables del Programa</h5>
                <p>
                  
                  <ul>
                  <li>Luis Ricardo Olvera Molina<br />                    
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>Teléfono de Contacto</h5>
                <p>
                (771) 71 9 32 93                            

                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Transparencia/pdfs/ROPs/ROP´S_Juventud_2023.pdf'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Reglas de Operación</a></strong></h5>
                <p>
                </p>
                
                <p>
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psatencionjuv;